const divFormTitle = {
  typographyTrue: 'Registro de Nuevo Equipo',
  typographyFalse: 'Editar Información del Equipo',
  typographyFinancialInfo: 'Editar Información Financiera do Equipamento',
};

export default divFormTitle;
